import { store } from "@betacrew/jars-flux";
import { componentKey, setStateNameList, setSelectedStateName, setFormNameList, setSelectedFormName, setTaxYearList, setSelectedTaxYear, setPayerList, setSelectedPayer, setPaginationState, setManageFormsStatePayrollGridData, setLoadingState, setUrlFormIdParam, setUrlPayerIdParam } from "./ManageStatePayrollFormsSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import ManageFormsService from "../../../../../services/ManageFormsService";
import General from "../../../../../libs/utility/General";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { MANAGE_FORMS_LOADING_STATES } from "../constants";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import { PAGE_STATE } from "../../../constants/constants";

export const { getManageStatePayrollStateNamesList, getManageStatePayrollFormsList, getManageStatePayrollTaxYearsList, getManageStatePayrollPayersList, getManageFormsStatePayrollGridData, viewManageStatePayrollPDF } = {

    getManageStatePayrollStateNamesList: (payload) => {
        return {
            type: "MANAGE_FORMS/MANAGE_STATE_PAYROLL_FORMS/GET_MANAGE_STATE_PAYROLL_STATE_NAMES_LIST",
            payload
        }
    },

    getManageStatePayrollFormsList: (payload) => {
        return {
            type: "MANAGE_FORMS/MANAGE_STATE_PAYROLL_FORMS/GET_MANAGE_STATE_PAYROLL_FORMS_LIST",
            payload
        }
    },

    getManageStatePayrollTaxYearsList: (payload) => {
        return {
            type: "MANAGE_FORMS/MANAGE_STATE_PAYROLL_FORMS/GET_MANAGE_STATE_PAYROLL_TAX_YEARS_LIST",
            payload
        }
    },

    getManageStatePayrollPayersList: (payload) => {
        return {
            type: "MANAGE_FORMS/MANAGE_STATE_PAYROLL_FORMS/GET_MANAGE_STATE_PAYROLL_PAYERS_LIST",
            payload
        }
    },

    getManageFormsStatePayrollGridData: (payload) => {
        return {
            type: "MANAGE_FORMS/MANAGE_STATE_PAYROLL_FORMS/GET_MANAGE_FORMS_STATE_PAYROLL_GRIDDATA",
            payload
        }
    },

    viewManageStatePayrollPDF: (payload) => {
        return {
            type: "MANAGE_FORMS/MANAGE_STATE_PAYROLL_FORMS/VIEW_PDF",
            payload
        }
    },

}

function* getManageStatePayrollStateNamesListAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_LOADING }))
        const { urlStateParam = null } = action.payload;
        const response = yield ManageFormsService.GetStatePayrollStates()
        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            if (Data, length > 0) {
                General.addOptionAndValueKeys(Data, "StateName", "StateName")
                yield put(setStateNameList(Data));

                if (urlStateParam) {
                    const findSelectedStateRecord = Data.find(state => state?.value === urlStateParam)
                    if (findSelectedStateRecord) {
                        yield put(setSelectedStateName(findSelectedStateRecord))
                    }
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "State Names not found." }));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch the state names List", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_READY }));
    }
}

function* getManageStatePayrollFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }))
        const { urlFormIdParam = null } = action.payload;
        const forms = action.payload.formNames;
        const response = yield ManageFormsService.GetStatePayrollFormNames(forms)

        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "PayrollFormName", "FormId")
                yield put(setFormNameList(Data));

                if (urlFormIdParam) {
                    const findSelectedFormRecord = Data.find(item => item?.value == urlFormIdParam)
                    if (findSelectedFormRecord) {
                        yield put(setSelectedFormName(findSelectedFormRecord))
                    }
                    yield put(setUrlFormIdParam(null));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Forms not found." }));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to get Forms List", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* getManageStatePayrollTaxYearsListAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading..." }))
        const { urlTaxYearParam = null } = action.payload;
        const response = yield ManageFormsService.GetStatePayrollTaxYears()
        const { Message, Status, Data } = response?.data || {};

        if (Status) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "ID", "ID")
                yield put(setTaxYearList(Data));

                if (urlTaxYearParam) {
                    const findSelectedTaxYearRecord = Data.find(taxYear => taxYear?.value === urlTaxYearParam)
                    if (findSelectedTaxYearRecord) {
                        yield put(setSelectedTaxYear(findSelectedTaxYearRecord))
                    }
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "Tax Years not found." }));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to get state names List", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* getManageStatePayrollPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING }))
        const { urlPayerIdParam = null } = action.payload;

        const params = action.payload.FormId;
        const response = yield ManageFormsService.GetStatePayrollPayers(params)
        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "PayerName", "PayerDetailId")
                yield put(setPayerList(Data));

                if (urlPayerIdParam) {
                    const findSelectedPayerRecord = Data.find(item => item?.value == urlPayerIdParam)
                    if (findSelectedPayerRecord) {
                        yield put(setSelectedPayer(findSelectedPayerRecord))
                    }
                    yield put(setUrlPayerIdParam(null));
                }
            }
            else {
                yield put(addNotifications({ heading: "Error", message: "Payers not found." }));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to get payers list", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getManageFormsStatePayrollGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING }))
        const { payer, taxYear, formId } = action.payload
        const params = {
            payer,
            taxYear,
            formId,
        }
        const response = yield ManageFormsService.getManageFormsStatePayrollGridData(params);
        const { Message, Status } = response?.data;
        const Data = General.extractDataFromResponseData(response?.data)

        if (Status) {
            if (Data.length > 0) {
                yield put(setManageFormsStatePayrollGridData(Data));
                yield put(setPaginationState({ totalRecipients: General.extractPaginationTotalFromResponse(response.data) }))
            } else {
                yield put(setManageFormsStatePayrollGridData([]));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to get Grid Data", message: Message }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* viewManageStatePayrollPDFAsync(action) {
    try {
        const { formId, payerId, formTypeId, payerName } = action.payload
        const data = {
            formId,
            payerId: payerId,
            formTypeId: formTypeId,
            PayerName: payerName,
            isUnMask: false,
            employerId: 0
        }

        yield put(setLoadingState({ state: `${MANAGE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LOADING}-${formId}` }))

        const response = yield SubmitFormsDataService.viewStatePayrollPDF(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data) {
                General.openBase64FileInNewTab(Data.Base64, Data.Name)
            } else {
                yield put(addNotifications({ heading: "Error", message: "PDF not found." }));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getManageStatePayrollStateNamesList().type, getManageStatePayrollStateNamesListAsync),
        takeLatest(getManageStatePayrollFormsList().type, getManageStatePayrollFormsListAsync),
        takeLatest(getManageStatePayrollTaxYearsList().type, getManageStatePayrollTaxYearsListAsync),
        takeLatest(getManageStatePayrollPayersList().type, getManageStatePayrollPayersListAsync),
        takeLatest(getManageFormsStatePayrollGridData().type, getManageFormsStatePayrollGridDataAsync),
        takeLatest(viewManageStatePayrollPDF().type, viewManageStatePayrollPDFAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);